function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 425;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive ^\.\/logo.(png|jpe?g|svg)$
// module id = 425
// module chunks = 1